import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { WidgetSettingsRes } from 'features/dashboard'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'

export const useFetchWidgetData = () => {
	const axiosPrivate = useAxiosPrivate()
	const {
		data: widgetData,
		isLoading: isWidgetDataLoading,
		isSuccess: isWidgetDataSuccess,
		refetch: refetchWidgetData
	} = useQuery<WidgetSettingsRes>({
		queryKey: queryKeys.widgetData.all,
		queryFn: () => axiosPrivate.get(apiRoutes.widget),
		enabled: false
	})

	return {
		widgetData,
		isWidgetDataLoading,
		isWidgetDataSuccess,
		refetchWidgetData
	}
}
